<template>
  <div>
    <h1 class="te-company-page-title co-display-8 mb-16 mt-5 text-center leading-none md:mb-20">
      運営会社
    </h1>
    <div class="w-full leading-loose">
      <div class="border-co-gray-6 border-b py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          会社名
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          株式会社ブリューアス
        </div>
      </div>
      <div class="border-co-gray-6 border-b py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          代表者
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          代表取締役社長 安川 昌平
        </div>
      </div>
      <div class="border-co-gray-6 border-b py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          所在地
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          東京都渋谷区渋谷一丁目2番5号
        </div>
      </div>
      <div class="border-co-gray-6 border-b py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          事業内容
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          プログラミング教育事業
        </div>
      </div>
      <div class="border-co-gray-6 border-b py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          許可番号
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          有料職業紹介事業許可番号 「13-ユ-307458」
        </div>
      </div>
      <div class="border-co-gray-6 border-b py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          設立
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          2009年2月2日
        </div>
      </div>
      <div class="border-co-gray-6 border-b py-4 sm:mx-2 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          親会社
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          ユナイテッド株式会社（東証グロース市場）
        </div>
      </div>
      <div class="co-mx-8 p-4 lg:flex">
        <div class="mb-2 basis-full text-center font-bold lg:mb-0 lg:basis-1/3">
          URL
        </div>
        <div class="basis-full text-center font-normal lg:basis-2/3 lg:text-left">
          <a
            href="https://brewus.co.jp"
            target="_blank"
          >https://brewus.co.jp</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-side-menu'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
    })
    return {
      title: '運営会社|テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
            'TechAcademyの運営会社に関する情報です。 ',
            ogUrl: '/company',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-company-page-title {
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}
</style>
